import React from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import cx from 'classnames';
import helpers from '../../resources/helpers';

import FormElementWrapper from '../core/FormElementWrapper';
import HiddenInput from '../form-elements/HiddenInput';

import './CompanyTypeAhead.scss';

class CompanyTypeAhead extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hasFocus: false,
			touched: false,
			hasValue: (props.value || '') !== '',
			value: props.value,
			demandbaseInfo: [],
		};
		this.inputRef = React.createRef();

		this.handleLabelClick = this.handleLabelClick.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.handleDemandbaseClick = this.handleDemandbaseClick.bind(this);
		this.handleValueChange = this.handleValueChange.bind(this);
	}

	componentWillReceiveProps(props) {
		const value = props.value;
		this.setState({
			hasValue: (value || '') !== '',
			value,
		});
	}

	async componentDidMount() {
		await this.loadDemandBaseScript();
		const $companyInput = this.inputRef.current;
		$companyInput.addEventListener('focus', () => {
			$companyInput.setAttribute('autocomplete', 'password-new');
		});

		const companyInputName = $companyInput.id;

		window.Demandbase.CompanyAutocomplete.widget({
			company: companyInputName,
			key: 'ceab1aa689651315fbeab8b1d1b4fbd679fdac75',
			callback: this.handleDemandbaseClick,
		});
	}

	async loadDemandBaseScript() {
		if (typeof window.Demandbase === 'undefined') {
			await helpers.createScriptTag('https://api.demandbase.com/autocomplete/widget.js');
		}
	}

	handleDemandbaseClick(data) {
		const demandbaseInfo = [];
		for (const key in data.pick || {}) {
			demandbaseInfo.push({ id: `demandbase_${key}`, value: data.pick[key] });
		}

		const value = data?.pick?.company_name || this.state.value;
		this.props.setValue(value);
		if (this.props.onChange) {
			this.props.onChange(value);
		}
		this.setState({
			value,
			hasValue: true,
			demandbaseInfo,
		});
	}

	// Event Handlers
	handleLabelClick() {
		this.inputRef.current.focus();
		this.setState({ hasFocus: true });
	}

	handleFocus() {
		const $dbInput = this.inputRef.current;
		$dbInput.setAttribute('autoComplete', 'new-password');

		if (this.props.onFocus) {
			this.props.onFocus();
		}
		this.setState({
			hasFocus: true,
			touched: true,
		});
	}

	handleBlur() {
		this.setState({ hasFocus: false });
	}

	handleValueChange(evt) {
		const value = evt.currentTarget.value;
		this.props.setValue(value);
		if (this.props.onChange) {
			this.props.onChange(value, this.state.touched);
		}
		this.setState({
			value,
			hasValue: true,
		});
	}

	render() {
		const props = this.props;
		const { showError, errorMessage } = helpers.shouldComponentShowError({
			showError: this.props.showError,
			formHasHadAnInValidSubmit: this.props.formHasHadAnInValidSubmit,
			required: this.props.required,
			getErrorMessage: () => props.errorMessage,
			errorMessage: props.errorMessage,
			currentValue: this.state.value,
		});

		return (
			<React.Fragment>
				<FormElementWrapper
					label={props.label}
					hideLabel={props.hideLabel}
					tooltip={props.tooltip}
					optionalLabel={props.optionalLabel}
					name={props.name}
					required={props.required}
					hasFocus={this.state.hasFocus}
					hasValue={this.state.hasValue}
					showError={showError}
					errorMessage={errorMessage}
					onLabelClick={this.handleLabelClick}>
					<input
						ref={this.inputRef}
						id={props.name}
						className={cx('basic-input__input', { 'basic-input__has-error': showError })}
						onFocus={this.handleFocus}
						onBlur={this.handleBlur}
						onChange={this.handleValueChange}
						name={props.name}
						value={this.state.value || ''}
						autoComplete="new-password"
					/>
				</FormElementWrapper>
				{this.state.demandbaseInfo.map((dbInfo, idx) => (
					<HiddenInput key={idx} name={dbInfo.id} value={dbInfo.value || ''} />
				))}
			</React.Fragment>
		);
	}
}

CompanyTypeAhead.propTypes = {
	required: PropTypes.bool,
	hidden: PropTypes.bool,
	hideLabel: PropTypes.bool,
	lockLabel: PropTypes.bool,
	label: PropTypes.string,
	tooltip: PropTypes.string,
	optionalLabel: PropTypes.string,
	className: PropTypes.string,
	showError: PropTypes.any,
	errorMessage: PropTypes.string,
	name: PropTypes.string.isRequired,
	value: PropTypes.any,
	getErrorMessage: PropTypes.func,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	formHasHadAnInValidSubmit: PropTypes.bool,
};

export default withFormsy(CompanyTypeAhead);
